// logo-cargando.controller.js
"use strict";

class logoCargandoController {
    constructor($sce) {
        this.$sce = $sce;
        this.efectos = ['WGirando','SwenoGirando','WDandoVueltas'];
        this.texto = 'Cargando...';
    }

    $onInit() {
        if (!this.efecto || this.efectos.indexOf(this.efecto)===-1) {
            this.efecto = 'WGirando';
        }
    }
}

logoCargandoController.$inject = ["$sce"];

export { logoCargandoController as LOGO_CARGANDO_CONTROLLER };
